import {get, post} from '../interceptor'
let preUrl = '/myApi/newsInfo'

export default {
  uploadImage (params) { return post(preUrl, '/uploadImage', params) },
  getNewsInfo (params) { return post(preUrl, '/getNewsInfo', params) },
  getNewsDetail (params) { return post(preUrl, '/getNewsDetail', params) },
  addNewsInfo (params) { return post(preUrl, '/addNewsInfo', params) },
  deleteNewsInfo (params) { return post(preUrl, '/delNewsInfo', params) }
}



// WEBPACK FOOTER //
// ./src/api/company/newsManage.js